"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var POLL_INTERVAL_DURATION = 300;
function pollForSelectMutation(selectElement, state, handleMutation) {
    var lastOuterHtml = selectElement.outerHTML;
    var pollIntervalId = window.setInterval(function () {
        var outerHTML = selectElement.outerHTML;
        if (outerHTML !== lastOuterHtml && !state.isKeying) {
            handleMutation();
        }
        lastOuterHtml = outerHTML;
    }, POLL_INTERVAL_DURATION);
    return pollIntervalId;
}
exports.default = pollForSelectMutation;
//# sourceMappingURL=pollForSelectMutation.js.map


//////////////////
// WEBPACK FOOTER
// /Volumes/Eoo/Repositories/legance/wp-content/themes/legance/node_modules/easydropdown/dist/Shared/Util/pollForSelectMutation.js
// module id = 83
// module chunks = 0